import { OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { getActiveProjectSelector } from '../../lead-generation/projects/projects.reducer';
import { GoToNextStateAction } from '../first-steps.actions';
import { UpdateProjectConfigurationAction } from '../../lead-generation/projects/projects.action';
import { LeadGenerationConfigurationService } from '../../lead-generation/shared/services/lead-generation-configuration.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AmplitudeService } from '../../shared/services/amplitude.service';
import { FormBuilder, Validators } from '@angular/forms';
import rawDomainRegex from '../../lead-generation/shared/regex/rawDomainRegex';
import { markFormAsTouched } from '../../lead-generation/shared/reactive-forms/forEachElementInForm';
var FirstStepsWebCallInstallationComponent = /** @class */ (function () {
    function FirstStepsWebCallInstallationComponent(store, leadGenerationService, translate, toastr, fb, amplitudeService) {
        this.store = store;
        this.leadGenerationService = leadGenerationService;
        this.translate = translate;
        this.toastr = toastr;
        this.fb = fb;
        this.amplitudeService = amplitudeService;
        this.checkInstallationUrl = '';
        this.checkingInstallation = false;
    }
    FirstStepsWebCallInstallationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.logAmplitude('Init');
        this.domainForm = this.fb.group({
            domainName: ['', Validators.pattern(rawDomainRegex)]
        });
        this.store.select(getActiveProjectSelector).subscribe(function (config) {
            _this.configuration = config;
        });
    };
    FirstStepsWebCallInstallationComponent.prototype.continueSteps = function () {
        if (this.domainForm.invalid) {
            this.logAmplitude('Continue - invalid domain', { domain: this.domain });
            markFormAsTouched(this.domainForm);
            return;
        }
        this.logAmplitude('Continue', { domain: this.domain });
        this.configuration.domainName = this.domain;
        this.store.dispatch(new UpdateProjectConfigurationAction(this.configuration));
        this.store.dispatch(new GoToNextStateAction());
    };
    FirstStepsWebCallInstallationComponent.prototype.doItLater = function () {
        this.logAmplitude('Do it later', { domain: this.domain });
        this.store.dispatch(new GoToNextStateAction());
    };
    FirstStepsWebCallInstallationComponent.prototype.showCodeInstalledStatus = function (isCodeInstalled) {
        var _this = this;
        this.logAmplitude('Showing installed code status', { domain: this.domain, isCodeInstalled: isCodeInstalled });
        var translationKey = isCodeInstalled ? 'CODE_INSTALLED' : 'CODE_NOT_INSTALLED';
        this.translate.get("LEAD_GENERATION.TOAST." + translationKey).subscribe(function (res) {
            isCodeInstalled ? _this.toastr.success(res) : _this.toastr.warning(res);
        });
    };
    FirstStepsWebCallInstallationComponent.prototype.handleCheckInstallationClick = function () {
        var _this = this;
        this.logAmplitude('Checking installed code', { domain: this.domain });
        this.checkingInstallation = true;
        this.leadGenerationService.checkInstallation(this.checkInstallationUrl).subscribe(function (_a) {
            var installed = _a.installed;
            _this.showCodeInstalledStatus(installed);
        }, function () {
            _this.showCodeInstalledStatus(false);
        }, function () {
            _this.checkingInstallation = false;
        });
    };
    Object.defineProperty(FirstStepsWebCallInstallationComponent.prototype, "domain", {
        get: function () {
            return this.domainForm.controls['domainName'].value;
        },
        enumerable: true,
        configurable: true
    });
    FirstStepsWebCallInstallationComponent.prototype.logAmplitude = function (message, event) {
        this.amplitudeService.logEvent("Panel:FirstSteps:WebCallInstallation: " + message, event);
    };
    return FirstStepsWebCallInstallationComponent;
}());
export { FirstStepsWebCallInstallationComponent };
